import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAppParams, IWebRequest } from 'src/app/shared/config/iapp.config';

@Injectable({
  providedIn: 'root',
})
export class PricerService {
  notifyUserLogin: () => Observable<any>;
  getPrice: (data: any, multiplier: any, groupNumber: any, forceNSAPricing: boolean, overrideFacilityCcn?: string | null) => Observable<any>;
  getIPPSPrice: (data: any, multiplier: any, groupNumber: any) => Observable<any>;

  constructor(
    @Inject('IWebRequest') private webRequest: IWebRequest,
    @Inject('IAppParams') private config: IAppParams
  ) {
    this.notifyUserLogin = () => {
      return this.webRequest.get<any>(this.config.getParams().restHost + 'user-login');
    };
    this.getPrice = (data, multiplier, groupNumber, forceNSAPricing, overrideFacilityCcn) => {
      const forceNSA: boolean = forceNSAPricing ?? false;
      console.log('Request: ', data);
      if (data.billType && data.billType.startsWith('0'))
        data.billType = data.billType.slice(1)
      return this.webRequest.post<any>(
        this.config.getParams().restHost + 'webpricer',
        data, {
          "multiplier": multiplier ?? '',
          "groupNumber": groupNumber ?? '',
          "force-nsa-pricing": forceNSA.toString(),
          "override-facility-ccn": overrideFacilityCcn ?? ''
        }
      );
    };
    this.getIPPSPrice = (data, multiplier, groupNumber) => {
      console.log('Request: ', data);
      return this.webRequest.post<any>(
        this.config.getParams().ippsHost, data, { "multiplier": multiplier ?? '', "groupNumber": groupNumber ?? '' }
      );
    };
  }
}
